export function StatusBar({
  stats,
  sources,
  pushOn,
}: {
  stats: { total_requests: number; ok_requests: number; last_24h: number } | null;
  sources: Record<string, boolean> | null;
  pushOn: boolean;
}) {
  const enabled = sources
    ? Object.entries(sources)
        .filter(([, v]) => v)
        .map(([k]) => k)
    : [];

  return (
    <footer className="status">
      <span className="status__item">
        <span className="status__led status__led--live" />
        LINK UP · intel.zyc.sh
      </span>
      <span className="status__item">
        REQ {stats?.total_requests ?? '—'} · 24h {stats?.last_24h ?? '—'}
      </span>
      <span className="status__item">
        SRC {enabled.length ? enabled.join(' · ') : 'local'}
      </span>
      <span className="status__item">{pushOn ? 'PUSH ON' : 'PUSH OFF'}</span>
    </footer>
  );
}
